export default __webpack_public_path__ + "static/media/maintenance.68c357de.jpg";